import type { PermitApplication } from '@src/orders/domain/PermitApplication';
import { TrailersFormName } from '@src/permitField/TrailerInformationFields';
import {
  EffectiveDateField,
  TripsFormName,
} from '@src/permitField/TripInformationFields';

export const getTrailerField = (
  fieldName: string,
  index: number,
  form: Record<string, unknown>,
): string | undefined => {
  const trailers = form[TrailersFormName];
  if (!trailers || !Array.isArray(trailers) || trailers.length <= index) {
    return;
  }
  return trailers[index][fieldName]?.toString();
};
export const findLeadTrailerValue = (
  fieldName: string,
  form: Record<string, unknown>,
) => {
  const trailers = form[TrailersFormName];
  if (!trailers || !Array.isArray(trailers)) {
    return;
  }
  for (const trailer of trailers) {
    const trailerValue = trailer[fieldName];
    if (trailerValue) {
      return trailerValue.toString();
    }
  }
};
export const getTripInformationValue = (
  field: string,
  form: Record<string, unknown>,
  permitApplication: PermitApplication,
): string | undefined => {
  const trips = form[TripsFormName] as Record<string, unknown> | undefined;
  if (!trips) {
    if (field === EffectiveDateField.fieldName)
      return permitApplication.effectiveDate.format();
    return form[field]?.toString();
  }

  const value = (trips[permitApplication.id] as Record<string, unknown>)?.[
    field
  ];
  return value?.toString();
};

export type ValueGetter = (
  field: string,
  form: Record<string, unknown>,
) => string | undefined;
